module.exports = __webpack_public_path__ + "arrow_red.56a9fa7e.png";